import { FC, useEffect, useState } from 'react'
import { Divider } from 'antd'
import { Pagination, CenteredSpin } from '../../../ui'
import style from './style.m.less'
import request from '../../../../services/request'
import { FilterSubmitted, GeneratorCardFiled } from '../../components'
import { IGeneratorFiled } from '../../components/GeneratorCard/GeneratorCardFiled'
import { EGoFiledStatusType } from '../../components/FilterSubmitted/FilterSubmitted'
import { ELoading } from '../../../../store/dictionaries/interfaces'
import { useAppSelector } from '../../../../store/hooks'

interface IGenaratorFiledData {
    gos_filed: IGeneratorFiled[]
    total: number
}

const PAGE_SIZE = 10

const FiledGenerators: FC = () => {
    const [page, setPage] = useState<number>(() => {
        if (localStorage.getItem('my_generators_page')) {
            return Number(localStorage.getItem('my_generators_page'))
        } else {
            localStorage.setItem('my_generators_page', '1')
            return 1
        }
    })
    const [pageSize, setPageSize] = useState<number>(() => {
        if (localStorage.getItem('my_generators_page_size')) {
            return Number(localStorage.getItem('my_generators_page_size'))
        } else {
            localStorage.setItem('my_generators_page_size', String(PAGE_SIZE))
            return PAGE_SIZE
        }
    })

    const [generators, setGenerators] = useState<IGenaratorFiledData>()
    const [loading, setLoading] = useState(true)

    const [energyType, setEnergyType] = useState<number>(() => {
        if (localStorage.getItem('my_generators_energy_type')) {
            return Number(localStorage.getItem('my_generators_energy_type'))
        } else {
            localStorage.setItem('my_generators_energy_type', String(0))
            return 0
        }
    })
    const handleChangeEnergyType = (type: number) => {
        setEnergyType(type)
        localStorage.setItem('my_generators_energy_type', String(type))
    }

    const [goStatus, setGoStatus] = useState<EGoFiledStatusType>(() => {
        if (localStorage.getItem('my_generators_status')) {
            return Number(localStorage.getItem('my_generators_status'))
        } else {
            localStorage.setItem('my_generators_status', String(EGoFiledStatusType.All))
            return EGoFiledStatusType.All
        }
    })
    const handleChangeStatus = (status: EGoFiledStatusType) => {
        setGoStatus(status)
        localStorage.setItem('my_generators_status', String(status))
    }

    const [region, setRegion] = useState<number>(() => {
        if (localStorage.getItem('my_generators_region')) {
            return Number(localStorage.getItem('my_generators_region'))
        } else {
            localStorage.setItem('my_generators_region', String(0))
            return 0
        }
    })
    const handleChangeRegion = (region: number) => {
        setRegion(region)
        localStorage.setItem('my_generators_region', String(region))
    }

    useEffect(() => {
        const loadGenerators = async () => {
            try {
                setLoading(true)
                const res = await request.post('/api/generators/v1/gos-filed', {
                    limit: pageSize,
                    offset: (page - 1) * pageSize,
                    filters: {
                        renewable_energy_type_id: energyType,
                        region_id: region,
                        status: goStatus,
                    },
                })
                setGenerators(res.data)
            } finally {
                setLoading(false)
            }
        }
        loadGenerators()
    }, [energyType, goStatus, region, page, pageSize])

    const dictionariesLoading = useAppSelector((state) => state.dictionaries.loading)

    const realLoading = dictionariesLoading !== ELoading.Loaded || loading || !generators

    return (
        <>
            <div className={style.contentWrapper}>
                <FilterSubmitted
                    energyType={energyType}
                    onChangeEnergyType={handleChangeEnergyType}
                    region={region}
                    onChangeRegionType={handleChangeRegion}
                    onChangeStatus={setGoStatus}
                />
                <Divider />
                <div className={style.cardsBlock}>
                    {realLoading && <CenteredSpin />}
                    {generators?.gos_filed?.map((item, index) => {
                        const { generator_id } = item
                        return (
                            <div key={generator_id}>
                                <GeneratorCardFiled generatorData={item} />
                                {index !== generators.gos_filed.length - 1 && <Divider />}
                            </div>
                        )
                    })}
                </div>
            </div>
            <Pagination
                customStyle={{ width: '100%' }}
                current={page}
                paginationChange={(receivedPage: number, size?: number) => {
                    setPage(receivedPage)
                    setPageSize(size ?? PAGE_SIZE)
                    localStorage.setItem('my_generators_page', String(receivedPage))
                    localStorage.setItem('my_generators_page_size', String(size ?? PAGE_SIZE))
                }}
                total={generators?.total ?? 0}
                showSizeChanger
                pageSize={pageSize}
            />
        </>
    )
}

export default FiledGenerators
